import * as React from 'react';
export const SVGComponent = (props) => (
  <svg
    height={16}
    viewBox='0 0 15.338 21.751'
    width={16}
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M38.376,43.661v9.934a1.269,1.269,0,0,1-2.539,0V51.189c0-.643.094-1.638-.857-1.638s-.857,1-.857,1.638v2.406a1.272,1.272,0,0,1-2.545,0V43.661a8.005,8.005,0,0,1-1.4-.863,7.881,7.881,0,0,1-2.822-4.22,1.353,1.353,0,0,1,2.614-.7,5.183,5.183,0,0,0,10.016,0,1.353,1.353,0,0,1,2.614.7,7.891,7.891,0,0,1-4.233,5.083Zm-3.4-10.551a3.424,3.424,0,1,1-3.42,3.427A3.43,3.43,0,0,1,34.981,33.11Z'
      data-name='Path 4377'
      fill='#007e75'
      id='Path_4377'
      transform='translate(-27.305 -33.11)'
    />
  </svg>
);
